import { setEmail } from "../../domain/subscribe/subscribeModel";
import { UpdateNewsletterStore, updateNewsletterUseCase } from "./updateNewsletterUseCase";

const clearNewsletterEmailUseCase = (store: UpdateNewsletterStore) => 
updateNewsletterUseCase(store, '', setEmail);


export { clearNewsletterEmailUseCase }